import { jsonParse } from 'utils/jsonUtil'

const getNoMainMenuFromV4 = store => {
  // 完全手动解析URL中的所有查询参数
  const fullUrl = window.location.href
  const urlObj = new URL(fullUrl)
  const noMainMenuFromV4 = urlObj.searchParams.get('noMainMenuFromV4') === 'true'

  if (noMainMenuFromV4 || window.parent !== window) {
    console.log('approvePayment', '5', noMainMenuFromV4)
    store.dispatch('mainMenu/setNoMainMenuFromV4', true)
  }
}

export const iframeInit = store => {
  getNoMainMenuFromV4(store)
  // 添加全局方法，用于导航到React路由 - 简化版本，直接使用路径
  window.navigateToReact = (path, callback) => {
    if (window.parent && window.parent !== window) {
      // 生成唯一导航ID
      const navigationId = `react_nav_${Date.now()}`

      // 保存回调函数
      if (callback && typeof callback === 'function') {
        if (!window.pendingNavigationCallbacks) {
          window.pendingNavigationCallbacks = {}
        }
        window.pendingNavigationCallbacks[navigationId] = callback
      }

      const data = JSON.stringify({
        path,
        navigationId,
        msgType: 'reactNavigate'
      })
      window.parent.postMessage(data, '*')
      return true
    }
    return false
  }
  // 添加全局方法，用于导航到React路由 - 简化版本，直接使用路径
  window.reactBack = () => {
    if (window.parent && window.parent !== window) {
      const data = JSON.stringify({
        msgType: 'reactBack'
      })
      window.parent.postMessage(data, '*')
      return true
    }
    return false
  }
  // 处理导航结果
  window.addEventListener('message', ev => {
    try {
      const data = typeof ev.data === 'string' ? jsonParse(ev.data) : ev.data

      // 处理导航结果消息
      if (data?.msgType === 'navigationResult' && data?.navigationId) {
        const { navigationId, success, message, path } = data

        // 如果有对应的回调函数，调用它
        if (window.pendingNavigationCallbacks && window.pendingNavigationCallbacks[navigationId]) {
          const callback = window.pendingNavigationCallbacks[navigationId]
          const callbackData = { success, message, path }
          callback(callbackData)
          // 移除已处理的回调
          delete window.pendingNavigationCallbacks[navigationId]
        }
      }
    } catch (error) {
      console.error('处理导航结果消息时出错:', error)
    }
  })
}

export default iframeInit
